import { connect } from 'react-redux'
import { recordAuditEvent } from '../../../modules/audit'
import {
  getIsJobSelected,
  getIsJobHovered,
  getIsJobDeleting,
  getJobPinColor,
} from '../../../modules/job'

const mapStateToProps = (state, props) => ({
  isSelected: getIsJobSelected(state, props),
  isHovered: getIsJobHovered(state, props),
  isDeleting: getIsJobDeleting(state, props),
  color: getJobPinColor(state, props),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchRecordJobClicked: (jobId) =>
    dispatch(
      recordAuditEvent.request({
        resource: 'job',
        action: 'read',
        resourceId: jobId,
      })
    ),
})

const redux = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component)

export { redux }
